var exports = {
  "fs": "VisualTab.module__sliderSection___Yks3OW",
  "Ry": "VisualTab.module__sliderHeader___Yks3OW",
  "mr": "VisualTab.module__sliderTitleRow___Yks3OW",
  "KF": "VisualTab.module__sliderLabel___Yks3OW",
};

module.exports = exports;
